<!-- 支付方式 -->
<template>
  <div class="payment">
    <div class="title">支付方式</div> 
    <div class="paybox">
      <ul class="pickbox" ref="pickbox">
        <li class="item" :class="{ checked: paymentList.wechatpay.checked }" data-payment="wechatpay" @click="selectPayment($event)" v-if="browser === 'wechat'">
          <img src="@/assets/order/wechat-pay.png" class="pay-icon" alt="pay-icon">
          <div class="pay-way">微信支付</div>
          <div class="check-icon"></div>
        </li>
        <li class="item" :class="{ checked: paymentList.alipay.checked }" data-payment="alipay" @click="selectPayment($event)" v-if="browser != 'wechat'">
          <img src="@/assets/order/ali-pay.png" class="pay-icon" alt="pay-icon">
          <div class="pay-way">支付宝</div>
          <div class="check-icon"></div>
        </li>
        <li class="item" :class="{ checked: paymentList.creditpay.checked }" hide data-payment="creditpay" @click="selectPayment($event)">
          <img src="@/assets/order/credit-pay.png" class="pay-icon" alt="pay-icon">
          <div class="pay-way">信用卡/储蓄卡支付</div>
          <div class="check-icon"></div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import browserCheck from '@/utils/checkBrowser'

export default {
  name: 'AppPayment',
  props: {
    
  },
  data() {
    return {
      browser: '',
      paymentList: {
        wechatpay: { checked: true },
        alipay: { checked: false },
        creditpay: { checked: false }
      }
    }
  },
  created() {
    // check browser
    this.browser = browserCheck.browser
  },
  mounted() {
    // select default payment
    let payment = this.$refs.pickbox.children[0].dataset.payment
    this.$emit('paymentSelected', payment)
    for (let item in this.paymentList) {
      this.paymentList[item].checked = false
      if (item == payment) this.paymentList[item].checked = true
    }
  },
  methods: {
    selectPayment(e) {
      let payment = e.currentTarget.dataset.payment
      for (let item in this.paymentList) {
        this.paymentList[item].checked = false
        if (item == payment) this.paymentList[item].checked = true
      }
      this.$emit('paymentSelected', payment)
    },
  },
}
</script>

<style lang="less" scoped>
  @import "~@/styles/fn";

  .payment {
    padding: 0 .4rem;
  }
  .title {
    margin-bottom: .24rem;
    font-size: .28rem;
    color: #a0a0a6;
  }
  .paybox {
    .pickbox {
      .item {
        display: flex;
        align-items: center;
        height: 1.2rem;
        .pay-icon {
          width: .64rem;
          height: .64rem;
        }
        .pay-way {
          flex: 1;
          padding-left: .24rem;
          font-size: .34rem;
          color: #6c6c74;
          font-weight: 500;
        }
        .check-icon {
          display: block;
          width: .44rem;
          height: .44rem;
          .bg("~@/assets/order/uncheck.png");
        }
      }
      .checked .check-icon {
        .bg("~@/assets/order/check.png");
      }
    }
  }
</style>
